export default __webpack_public_path__ + "static/25-8e0f51d177e7b2c39d574a03a1e0675b.jpg";